<template>
  <div class="carousel-container">
    <h3>Was unsere Kunden sagen</h3>
    <div class="carousel-track">
      <!-- Durch Doppeldaten wird ein nahtloser Loop ermöglicht -->
      <div
        class="carousel-slide"
        v-for="(review, index) in duplicatedReviews"
        :key="index"
      >
        <p class="review-text">{{ review.text }}</p>
        <div class="reviewer">
          <span class="reviewer-name">{{ review.name }}</span> –
          <span class="reviewer-title">{{ review.title }}</span>
        </div>
        <div class="review-meta">{{ review.info }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reviews: [
        {
          text: "🗣️ „EasyRight hat mir in wenigen Minuten geholfen, eine professionelle Datenschutzerklärung zu erstellen. Top Service!“",
          name: "Anna M.",
          title: "Gründerin",
          info: "Mehr als 10.000 zufriedene Kunden - Bewertung: ⭐⭐⭐⭐⭐ (4,9/5, basierend auf 2.200+ Bewertungen)",
        },
        {
          text: "🗣️ „Die Nutzung von EasyRight ist ein Kinderspiel. Die Schritt-für-Schritt-Anleitung war sehr hilfreich und der Service unschlagbar.“",
          name: "Markus F.",
          title: "Geschäftsführer",
          info: "Mehr als 10.000 zufriedene Kunden - Bewertung: ⭐⭐⭐⭐⭐ (4,9/5, basierend auf 2.200+ Bewertungen)",
        },
        {
          text: "🗣️ „Ich bin beeindruckt, wie schnell und einfach ich mein rechtssicheres Dokument erhalten habe. Sehr zu empfehlen!“",
          name: "Sabine K.",
          title: "Marketing Managerin",
          info: "Mehr als 10.000 zufriedene Kunden - Bewertung: ⭐⭐⭐⭐⭐ (4,9/5, basierend auf 2.200+ Bewertungen)",
        },
        {
          text: "🗣️ „Der Prozess war intuitiv und effizient - eine echte Zeitersparnis!“",
          name: "Felix L.",
          title: "Startup Gründer",
          info: "Mehr als 10.000 zufriedene Kunden - Bewertung: ⭐⭐⭐⭐⭐ (4,9/5, basierend auf 2.200+ Bewertungen)",
        },
      ],
    };
  },
  computed: {
    duplicatedReviews() {
      return [...this.reviews, ...this.reviews];
    },
  },
};
</script>

<style scoped>
.carousel-container {
  margin: 0 auto;
  overflow: hidden;
  width: 75%;
  background: #fff;
  padding: 20px 0;
  margin-bottom: 100px;
}

h3 {
  margin-top: 100px;
  margin-bottom: 50px;
  font-size: 30px;
  color: #333;
}

.carousel-track {
  display: flex;
  animation: scroll 20s linear infinite;
}

.carousel-slide {
  flex: 0 0 300px;
  margin-right: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}

.review-text {
  font-size: 18px;
  color: #555;
  margin-bottom: 10px;
  font-style: italic;
}

.reviewer {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
}

.review-meta {
  font-size: 12px;
  color: #777;
}

/* Keyframes für kontinuierliches Scrollen */
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    /* Übersetzt um die halbe Breite des doppelten Inhalts (nahtloser Loop) */
    transform: translateX(-50%);
  }
}

/* Responsive Anpassungen */
@media (max-width: 768px) {
  .carousel-slide {
    flex: 0 0 250px;
    margin-right: 15px;
  }
}
</style>
